var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "188",
        height: "142",
        viewBox: "0 0 188 142",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M188.008 0H0V141.266H188.008V0Z", fill: "#1C84F1" },
      }),
      _c("path", {
        attrs: {
          d: "M0 141V0H188C188 77.872 108.542 141 10.5265 141H0Z",
          fill: "#24A5FA",
        },
      }),
      _c("path", {
        attrs: {
          d: "M97.7847 5.78071e-05L0 0V69.3597H5.47516C56.4561 69.3597 97.7847 38.3062 97.7847 5.78071e-05Z",
          fill: "#1C84F1",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }